// Abu Dhabi - personal trainer price. Framed around monthly and family costs.
const content = {
    slug: 'personal-trainer-price',
    title: (c) => `Personal Trainer Price in Abu Dhabi | From ${c.money(c.lowest, 0)} a Session`,
    description: (c) =>
        `Personal trainer prices in Abu Dhabi: ${c.money(c.lowest, 0)} to ${c.money(c.pt('Elite', 14), 0)} a session, monthly costs at 2 or 3 sessions a week, and partner rates.`,
    eyebrow: 'Abu Dhabi · Prices',
    h1: 'Personal Trainer Prices in Abu Dhabi',
    lead: 'Prices per session are only half the picture. Here is what personal training costs per month in Abu Dhabi at two or three sessions a week - and how families bring the cost down.',
    image: 'fitness-package5.jpg',
    imageAlt: 'Client training with a personal trainer',
    facts: ['Monthly cost examples', 'Partner rates', 'No joining fee'],
    packagesTitle: 'Package prices',
    sections: [
        {
            title: 'What it costs per month',
            cards: [
                { title: '2 sessions a week', body: (c) => `About 8-9 sessions a month. On the 24-session Signature package that is roughly ${c.money(c.pt('Signature', 24) * 8.5, 0)} a month.` },
                { title: '3 sessions a week', body: (c) => `About 13 sessions a month. On the 50-session Signature package that is roughly ${c.money(c.pt('Signature', 50) * 13, 0)} a month.` },
                { title: 'Training as a couple', body: (c) => `On the partner rate, each person pays about ${c.money(Math.round(c.pt('Signature', 30) * 0.7), 0)} a session on the 30-session package.` },
            ],
        },
        {
            title: 'How this compares in Abu Dhabi',
            tone: 'muted',
            paragraphs: [
                'Home personal training in Abu Dhabi is commonly advertised at around AED 270 to AED 300 for a one-to-one session, with pair sessions higher. Our rates sit well below that while we build our client base in the city, with no joining fee and no gym membership needed.',
            ],
        },
    ],
    faqs: [
        {
            question: 'How much does a personal trainer cost per month in Abu Dhabi?',
            answer: (c) => `At two sessions a week on a Signature package, roughly ${c.money(c.pt('Signature', 24) * 8.5, 0)} a month. Longer packages and partner training lower the monthly cost.`,
        },
        {
            question: 'Do evening and weekend sessions cost more?',
            answer: (c) => `Yes, by ${c.money(c.mods.peak, 0)} a session. Weekday sessions between 9am and 4pm are at the listed price.`,
        },
        {
            question: 'Can family members share a package?',
            answer: 'Two people training together in the same session can use the partner rate. Separate sessions need separate packages.',
        },
    ],
    schema: { name: 'Personal Trainer Prices in Abu Dhabi' },
}

export default content
